import { dispatchCartUpdateEvents } from './_global-functions.js';

class ATCButton extends HTMLElement {
  constructor() {
    super();
    this.productHandle = this.getAttribute('product');
    this.buttonClasses = this.getAttribute('buttonClass')
    this.showQuantity = this.getAttribute('show-quantity') === 'true';
    this.expectedShipping = this.getAttribute('expectedShipping');

    // if(this.buttonClasses.length <= 0) this.buttonClasses = 'btn--primary';
  }

  connectedCallback() {
    this.getProduct(this.productHandle)
      .then(product => {

        const expectedShippingMessage = this.expectedShipping;

        const title = this.getAttribute('title') ?? 'Add to Cart';
         
        this.innerHTML = `
        <button class="${this.buttonClasses}" type="submit" atc ${!product.available ? 'disabled' : ''}>
          ${title}
        </button>`;
        
        if (this.showQuantity) {
          this.innerHTML = `
            <div class="quantity-selector">
              <button type="button" minus>.</button>
              <input type="text" name="quantity" value="1" min="1" quantity>
              <button type="button" plus>.</button>
              
            </div> ${this.innerHTML}`;
        }
      
        this.atc = this.querySelector('[atc]');

        if (this.showQuantity) {
          this.quantity = this.querySelector('[quantity]');
          this.minus = this.querySelector('[minus]');
          this.plus = this.querySelector('[plus]');
        }
        

        this.variant = product.variants[0].id;
        this.name = product.title;
        this.quantityValue = 1 ;

        // Cart Icon
        this.mainContainer = document.querySelector('.main-menu-desktop__cart-container');
        this.el_cart_icon_container = document.querySelector('#cart-count-widget-contaioner');
        this.el_cart_count_text = document.querySelector('#cart-count-display');
        this.el_cart_icon_mobile_container = document.querySelector('#cart-count-widget-mobile-contaioner');
        this.el_cart_count_mobile_text = document.querySelector('#cart-count-mobile-display');
        this.el_cart_count_popup_text = document.querySelector('#cart-count-popup-display');
        
        if(this.showQuantity) this.initQuantityEvents();
        this.atc.addEventListener('click', () => this.addToCart(expectedShippingMessage));
      });
  }

  async getProduct(product) {
    try {
      const response = await fetch(window.Shopify.routes.root + `products/${product}.js`);
      return await response.json();
    } catch (error) {
      console.error('Error:', error);
    }
  }

  initQuantityEvents() {
    this.plus.addEventListener('click', () => this.quantityMutation('plus'));
    this.minus.addEventListener('click', () => this.quantityMutation('minus'));
    this.quantity.addEventListener('change', (e) => this.setValue(e.target.value));
  }

  setValue(value) {
    if (value < 1) value = 1;
    this.quantityValue = Number(value);
    this.quantity.value = this.quantityValue;
  }

  quantityMutation(action) {
    let currentQuantity = this.quantityValue;
    currentQuantity = (action === 'plus') ? currentQuantity + 1 : currentQuantity - 1;
    this.setValue(currentQuantity);
  }

  removeModal = (modal, target) => {
    modal.close();
    setTimeout(() => {
      modal.remove();
      target.removeEventListener('click', this.removeModal);
    }, 100);
  }

  createModal() {
    const modal = document.createElement('dialog');
    modal.className = 'atcModal';

    modal.innerHTML = `
      <div class="modal-content">
        <div class="close-button" role="button" close>X</div>
        <h2>${ this.name } has been added to your cart!</h2>
        <div class="modal-actions">
          <button class="btn--primary active" role="button" close>Keep Shopping</button>
          <a class="btn--primary" href="/cart">View Cart</a>
        </div>
      </div>
    `;

    document.body.appendChild(modal);

    modal.showModal();

    document.body.addEventListener('click', function closeModal() {
      modal.close();
      document.body.removeEventListener('click', closeModal);
    });
    
    document.addEventListener('click', (e) => {
      if(e.target === modal) this.removeModal(modal, document);
    });

    modal.querySelectorAll('[close]').forEach(close => 
      close.addEventListener('click', () => this.removeModal(modal, close)));
  }

  updateCartIcon() {
    fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
    }).then(response => {
      return response.json();
    })
    .then((data) => {
      const cart_count = data.item_count;

      this.el_cart_count_text.innerHTML = cart_count;
      this.el_cart_count_mobile_text.innerHTML = cart_count;

      if(this.el_cart_count_popup_text)
        this.el_cart_count_popup_text.innerHTML = cart_count;

      this.mainContainer.style['display'] = cart_count == 0 ? 'none' : 'block';
      this.el_cart_icon_container.style['display'] = cart_count == 0 ? 'none' : 'block';
      this.el_cart_icon_mobile_container.style['display'] = cart_count == 0 ? 'none' : 'block';
    
    }).catch((error) => {
      console.error('Error:', error);
    });
    
  }

  addToCart(message) {
    
    this.atc.setAttribute('disabled', 'disabled');

    let data = null;

    if (message) {
      data = {
        items: [
          {
            id: this.variant,
            quantity: this.quantityValue,
            properties: {
              "Estimated Shipping": message
            }
          }
        ]
      }
    } else {
      data = {
        items: [
          {
            id: this.variant,
            quantity: this.quantityValue
          }
        ]
      }
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => {
      return response.json();
    })
    .then((cartData) => {
      this.updateCartIcon();
      // trigger modal
      this.createModal();
      this.atc.removeAttribute('disabled');
      
      // Dispatch proper cart update events
      dispatchCartUpdateEvents(cartData, data.items);
      
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

customElements.define('add-to-cart-button', ATCButton);